<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Stripe Plans</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in plans..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('stripePlanId')">Stripe Plan Id</th>
              <th class="col-1" @click="toggleSort('stripeConfigurationId')">Stripe Configuration Id </th>
              <th class="col-1" @click="toggleSort('planId')">Plan Id</th>
              <th class="col-1" @click="toggleSort('stripeProductId')">Stripe Product Id</th>
              <th class="col-1" @click="toggleSort('stripePriceId')">Stripe Price Id</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.stripePlanId">
              <td class="col-1 text-truncate" v-html="truncateText(config.stripePlanId, 30)" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeConfigurationId, 30)" @click="selectText" :data-text="config.stripeConfigurationId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.planId, 30)" @click="selectText" :data-text="config.planId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeProductId, 30)" @click="selectText" :data-text="config.stripeProductId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripePriceId, 30)" @click="selectText" :data-text="config.stripePriceId"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'StripePlanEdit', params: { id: config.stripePlanId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";

export default {
  name: "StripePlans",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      StripePlansList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
    };
  },
  computed: {
    filteredStripePlansList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.StripePlansList.filter((config) => {
        return (
            (config.stripePlanId && config.stripePlanId.toString().includes(search)) ||
            (config.stripeConfigurationId && config.stripeConfigurationId.toString().includes(search)) ||
            (config.planId && config.planId.toLowerCase().includes(search)) ||
            (config.stripeProductId && config.stripeProductId.toLowerCase().includes(search)) ||
            (config.stripePriceId && config.stripePriceId.toLowerCase().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredStripePlansList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'stripePlanId';
  },
  methods: {
    doLoadPlans() {
      AdminService.getStripePlansList().then((data) => {
        this.StripePlansList = data;
      }).catch((error) => {
        this.error = error.message
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },

    redirectToCreate() {
      this.$router.push({ name: 'StripePlanCreate' }); // Navigate to the StripeEdit route without params
    },

    truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (error) {
        this.error = error.message
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>